import { adminAPIService, adminFileDownloadService, goxipAPIService, newhopeAPIService } from './index'

const route = 'stores'

export const getStoreList = (type) => {
  const params = {
    type,
  }

  return adminAPIService({
    url: `${route}/list`,
    method: 'get',
    params,
  })
}

export const getStoresWithPaging = ({
  type = 'affiliates',
  keyword = '',
  storeId,
  advertiserId,
  page = 1,
  size = 20,
  is_deeplink = 0,
}) => {
  const params = {
    page,
    size,
    is_deeplink,
  }

  if (keyword) {
    params.keyword = keyword
  }
  if (storeId) {
    params.store_id = storeId
  }
  if (advertiserId) {
    params.advertiser_id = advertiserId
  }

  return adminAPIService({
    url: `${route}/${type}`,
    method: 'get',
    params,
  })
}

export const getAffiliateStoresWithPaging = ({
  keyword = '',
  storeId,
  advertiserId,
  page = 1,
  size = 20,
  is_deeplink = 0,
}) => {
  const params = {
    page,
    size,
    is_deeplink,
  }

  if (keyword) {
    params.keyword = keyword
  }
  if (storeId) {
    params.store_id = storeId
  }
  if (advertiserId) {
    params.advertiser_id = advertiserId
  }

  return newhopeAPIService({
    url: `${route}/affiliates`,
    method: 'get',
    params,
  })
}

export const getSubscriptions = ({
  payment_month,
  type,
  status,
}) => {
  const params = {}

  if (payment_month) {
    params.payment_month = payment_month
  }
  if (type) {
    params.type = type
  }
  if (status) {
    params.status = status
  }

  return adminAPIService({
    url: `${route}/subscriptions/list`,
    method: 'get',
    params,
  })
}

export const getSubscriptionPlanDetail = planId => adminAPIService({
  url: `${route}/subscriptions/plans/${planId}`,
  method: 'get',
})

export const getStoreDetail = storeId => adminAPIService({
  url: `${route}/${storeId}`,
  method: 'get',
})

export const createStore = (store, member_profile_image, banner_image, coupon_image) => {
  const formData = new FormData()
  formData.append('json', JSON.stringify(store))
  formData.append('member_profile_image', member_profile_image)
  formData.append('banner_image', banner_image)
  formData.append('coupon_image', coupon_image)
  // const body = `json=${encodeURIComponent(JSON.stringify(store))}`
  return newhopeAPIService({
    url: `${route}`,
    method: 'post',
    data: formData,
  })
}

export const updateStore = (store, storeId, member_profile_image, banner_image, coupon_image) => {
  const formData = new FormData()
  formData.append('json', JSON.stringify(store))
  formData.append('member_profile_image', member_profile_image)
  formData.append('banner_image', banner_image)
  formData.append('coupon_image', coupon_image)
  return adminAPIService({
    url: `${route}/${storeId}`,
    method: 'post',
    data: formData,
  })
}

export const createStoreSubscription = (store_id, detail) => {
  const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
  return adminAPIService({
    url: `${route}/${store_id}/subscriptions/`,
    method: 'post',
    data: body,
  })
}

export const terminateStoreSubscription = (subscripbtion_id, detail) => {
  const body = `json=${encodeURIComponent(JSON.stringify(detail))}`
  return adminAPIService({
    url: `${route}/subscriptions/${subscripbtion_id}/terminate`,
    method: 'post',
    data: body,
  })
}

export const checkSlugAvailability = (slug) => {

  return new Promise((resolve, reject) => {
    goxipAPIService({
      url: `v3/newhope-admin/${route}/slug/${slug}`,
      method: 'get',
    }).then((result)=>{
      if (result.data.data == true) {
        resolve()
      }
      reject('STORE_SLUG_EXIST')
    })
  })
}

export const resetStoreMemberPassword = storeId => adminAPIService({
  url: `${route}/${storeId}/reset-member-password`,
  method: 'post',
})

export const getStoreSubscriptionBilling = ({
  storeId,
  page = 1,
  size = 20,
}) => {
  const params = {
    storeId,
    page,
    size,
  }

  return adminAPIService({
    url: `${route}/${storeId}/subscriptions/billings`,
    method: 'get',
    params: params,
  })
}